import React from "react";
import ReactModal from "react-modal";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import useAuthStore from "../../stores/useAuthStore";
import { fundWalletHandler } from "../../helpers/paymentHandler";

import { useQueryClient } from "@tanstack/react-query";

const BtnCreditWallet = ({ modern }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const [amount, setamount] = React.useState(undefined);
  const queryClient = useQueryClient();

  const [loading, setloading] = React.useState(false);
  const { user } = useAuthStore();

  const _save = async () => {
    try {
      const { _id: studentid } = user;

      if (is_null(amount) || parseFloat(amount) <= 0) {
        swal("error", "Please enter a valid amount", undefined);
        return;
      }

      setloading(true);

      await fundWalletHandler(amount, { studentid }, () => {
        queryClient.invalidateQueries(["myWalletDataset"]);
        _close();
      });

      setloading(false);
    } catch ({ message }) {
      setloading(false);
      swal("error", message);
    }
  };

  const _close = () => {
    setshowmodal(false);
  };
  const _show = () => {
    setshowmodal(true);
  };

  return (
    <>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">CREDIT STUDENT WALLET</h5>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail2">Enter amount you wish to deposit in your wallet (Example 1000 for N1,000.00)</label>
                <input
                  type="number"
                  className="form-control form-control-lg"
                  id="exampleInputEmail2"
                  onChange={(e) => setamount(e.target.value)}
                  placeholder="Enter amount you wish to deposit in your wallet"
                  value={amount}
                />
              </div>
            </div>
            <div className="modal-footer">
              {loading ? (
                <button type="button" className="btn btn-primary">
                  Please wait...
                </button>
              ) : (
                <button type="button" className="btn btn-primary" onClick={_save}>
                  Deposit Money
                </button>
              )}
              <button type="button" className="btn btn-danger" onClick={_close}>
                Close
              </button>
            </div>
          </div>
        </div>
      </ReactModal>

      {modern ? (
        <button
          onClick={_show}
          style={{
            background: "rgba(255, 255, 255, 0.15)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            color: "white",
            padding: "12px 28px",
            borderRadius: "12px",
            fontWeight: "700",
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            cursor: "pointer",
          }}
        >
          <i className="fa fa-plus-circle"></i> Add Funds
        </button>
      ) : (
        <div
          style={{
            position: "absolute",
            right: "50px",
            bottom: "-50px",
          }}
        >
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="fa fa-plus"></i>
          </button>
        </div>
      )}
    </>
  );
};

export default BtnCreditWallet;
